import { Formik, Form, ErrorMessage, Field } from "formik";
import "./borradorActos.scss";
import { useState, useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import {
  getSolicitud,
  validarAlta,
  sendBorradorS1,
  updateBorradorS1,
} from "../../../services/DatoPersonalService";
import { useLocalStorage } from "../../../../hooks/useLocalStorage";
import Header from "../../header/Header";
import {
  SpinnerCircle,

} from "../../../atoms/spinner/Spinner";
import Footer from "../../footer/Footer";
import ModalMensajes from "../../modals/modalMensajes/ModalMensajes";
import ModalPresentar from "../../modals/modalPresentar/modalPresentar";
import { eliminarPropiedadObj } from "../../../../utils/Utils";
import {
  getIhTipVia,
  getIhPaises,
  getIhProvincias,
  getIhMunicipios,
  getIhLocalidades,
} from "../../../services/IhService";
import { getDatosIhPersona } from "../../../services/IhPersonaService";

const BorradorActos = () => {
  const [show, setShow] = useState({
    mensaje: false,
    modalPresentar: false,
  });
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [estado] = useState(false);
  const [estados, setEstados] = useState({
    datos: false,
    tipVia: false,
    paises: false,
    provincias: false,
    municipios: false,
    localidades: false,
  });
  // const [disablePresentar, setDisablePresentar] = useState(false);
  const [ihPaises, setIhPaises] = useState([]);
  const [ihTipVia, setIhTipoVia] = useState([]);
  const [IhProvincias, setIhProvincias] = useState([]);
  const [ihMunicipios, setIhMunicipios] = useState([]);
  const [ihLocalidades, setIhLocalidades] = useState([]);
  const [user] = useLocalStorage("user", "");
  const location = useLocation();

  const handlePais = (paisSeleccionado, setFieldValue) => {
    // Reset campos
    setDatos((prev) => ({
      ...prev,
      locmunprvcprodom: "",
      locmuncmunicipio: "",
      locclocalidad: "",
      cpostal: "",
    }));

    // Reset Formik
    setFieldValue("locmunprvcprodom", "");
    setFieldValue("locmuncmunicipio", "");
    setFieldValue("locclocalidad", "");
    setFieldValue("cpostal", "");

    // Reset arrays
    setIhProvincias([]);
    setIhMunicipios([]);
    setIhLocalidades([]);

    setEstados((prev) => ({
      ...prev,
      provincias: false,
      municipios: false,
      localidades: false,
    }));

    // Si el país no es vacío, cargar provincias
    if (paisSeleccionado) {
      getIhProvincias(paisSeleccionado).then((data) => {
        if (!data.toString().startsWith("Error:") && data.length > 0) {
          setIhProvincias(data);
          setEstados((prev) => ({ ...prev, provincias: true }));
        }
      });
    }
  };




  const handleProvincia = (valores, setFieldValue) => {
    // Vaciar los campos dependientes
    setDatos((prevState) => ({
      ...prevState,
      locclocalidad: "",
      locmuncmunicipio: "",
      cpostal: "",
    }));

    // Vaciar también los valores en Formik
    setFieldValue("locmuncmunicipio", "");
    setFieldValue("locclocalidad", "");
    setFieldValue("cpostal", "");

    // Reiniciar estados
    setEstados((prevState) => ({
      ...prevState,
      municipios: false,
      localidades: false,
    }));

    setIhMunicipios([]);
    setIhLocalidades([]);

    // Cargar municipios
    if (valores.locmunprvpaicpaidom && valores.locmunprvcprodom) {
      getIhMunicipios(valores.locmunprvpaicpaidom, valores.locmunprvcprodom)
        .then((data) => {
          if (!data.toString().startsWith("Error:")) {
            setIhMunicipios(data);
            setEstados((prevState) => ({
              ...prevState,
              municipios: true,
            }));
          }
        });
    } else {
      setIhMunicipios([]);
      setIhLocalidades([]);
    }
  };


  const handleMuncipios = (valores, setFieldValue) => {
    setDatos((prevState) => ({
      ...prevState,
      locclocalidad: "",
    }));

    // 🔹 Vaciar dentro de Formik
    setFieldValue("locclocalidad", "");

    setEstados((prevState) => ({
      ...prevState,
      localidades: false,
    }));

    if (
      valores.locmunprvpaicpaidom &&
      valores.locmunprvcprodom &&
      valores.locmuncmunicipio
    ) {
      getIhLocalidades(
        valores.locmunprvpaicpaidom,
        valores.locmunprvcprodom,
        valores.locmuncmunicipio
      ).then((data) => {
        if (!data.toString().startsWith("Error:")) {
          setIhLocalidades(data);
          setEstados((prevState) => ({
            ...prevState,
            localidades: true,
          }));
        }
      });
    } else {
      setIhLocalidades([]);
    }
  };


  const mandarBorrador = (valores) => {
    if (valores.niep.length === 9) {
      valores.niep = valores.niep.substring(
        0,
        valores.niep.length - 1
      );
    }
    valores.niep = valores?.niep?.replace(/[^0-9]/g, "")


    validarAlta(params?.id ? 9999 : 99999, "s1").then((data) => {

      if (data.estado) {

        if (params?.id !== undefined) {
          valores.saaxsolactadm = params.id;

          updateBorradorS1(params?.id, valores).then((data) => {
            if (data.toString().startsWith("Error:")) {
              setShow({
                mensaje: true,
                content: data,
                tipo: "tituloBorrador",
                destinoCerrar: "/variacionDatosPersonales",
                destinoAviso: null,
              });
            } else {
              setShow({
                mensaje: true,
                content: "Borrador guardado correctamente.",
                tipo: "tituloBorrador",
                destinoCerrar: "/variacionDatosPersonales",
                destinoAviso: null,
              });
            }
          });
        } else {

          // añadir tipo acto cuando se ajuste el path

          sendBorradorS1(valores).then((data) => {
            if (data.toString().startsWith("Error:")) {
              setShow({
                mensaje: true,
                content: data,
                tipo: "tituloBorrador rojo",
                destinoAviso: null,
                destinoCerrar: null,
              });
            } else {
              setShow({
                mensaje: true,
                content: "Borrador guardado correctamente.",
                tipo: "tituloBorrador",
                destinoCerrar: "/variacionDatosPersonales",
                destinoAviso: null,
              });
            }
          });
        }
      } else {
        setShow({
          mensaje: true,
          content: data.descripcion,
          contentBold: "¿Estás seguro/a?",
          tipo: "tituloModal",
          aviso: false,
          destinoAviso: null,
          destinoCerrar: null,
        });
      }
    });
  };
  let navigate = useNavigate();

  const handleClose = (e) => {
    setShow(false);
  };

  // const [borrador] = useState(false);

  const [datos, setDatos] = useState({
    nombreBorrador: "",
    tipiep: "", //Preguntar
    niep: "",
    letfiniep: "",
    letiniiep: "",
    apellido1: "",
    apellido2: "",
    nombre: "",
    dtipvia: "",
    dcalle: "",
    ncalle: "",
    escalera: "",
    npiso: "",
    puerta: "",
    lbis: "",
    dacldom: "", //Aclarador / complemento domicilio
    cpostal: "",
    locmunprvpaicpaidom: "", //Pais
    locmunprvcprodom: "", //Provincia
    locmuncmunicipio: "", //Muninicipio
    locclocalidad: "", //Localidad
    ntelefono: "",
    correoPersonal: ""
  });

  useEffect(() => {
    if (estados.datos && !(estados.paises || estados.tipVia)) {
      getIhPaises().then((data) => {
        if (!data.toString().startsWith("Error:")) {
          setIhPaises(data);
          setEstados((prevState) => ({
            ...prevState,
            paises: true,
          }));
        }
      });

      getIhTipVia().then((data) => {
        // 

        if (!data.toString().startsWith("Error:")) {
          setIhTipoVia(data);
          setEstados((prevState) => ({
            ...prevState,
            tipVia: true,
          }));
        }
      });
if (datos.locmunprvpaicpaidom==="724") {
   getIhProvincias("724").then((data) => {
        if (!data.toString().startsWith("Error:")) {
          setIhProvincias(data);
          setEstados((prevState) => ({
            ...prevState,
            provincias: true,
          }));
        }
      });
    }
}
   

    if (!estados.datos) {
      if (params?.id !== undefined && params?.id !== null) {
        getSolicitud(params.id, "s1").then((data) => {
          if (!data.toString().startsWith("Error:")) {
            setDatos((prevState) => ({
              ...prevState,
              apellido1: user.apellido1,
              apellido2: user.apellido2,
              nombre: user.nombre,
              niep: user.niep,
              letiniiep: data.letiniiep,
              letfiniep: data.letfiniep,
              nombreBorrador: location?.state.nombreBorrador
                ? location?.state.nombreBorrador
                : "",
              locclocalidadlocclocalidad: data?.locclocalidad
                ? data?.locclocalidad
                : "",
              locmunprvcprodom: data?.locmunprvcprodom
                ? data?.locmunprvcprodom
                : "",
              cpostal: data?.cpostal ? data?.cpostal : "",
              dcalle: data?.dcalle ? data?.dcalle : "",
              locclocalidad: data?.locclocalidad ? data?.locclocalidad : "",
              locmunprvpaicpaidom: data?.locmunprvpaicpaidom
                ? data?.locmunprvpaicpaidom
                : "",
              locmuncmunicipio: data?.locmuncmunicipio
                ? data?.locmuncmunicipio
                : "",
              ntelefono: data?.ntelefono ? data?.ntelefono : "",
              dtipvia: data?.dtipvia ? data?.dtipvia : "",
              ncalle: data?.ncalle ? data?.ncalle : "",
              escalera: data?.escalera ? data?.escalera : "",
              npiso: data?.npiso ? data?.npiso : "",
              puerta: data?.puerta ? data?.puerta : "",
              lbis: data?.lbis === "S" ? true : false,
              dacldom: data?.dacldom ? data?.dacldom : "",
              correoPersonal: data?.correoPersonal ? data?.correoPersonal : "",
              tipiep: data?.tipiep ? data?.tipiep : ""
            }));
          }

          if (data.locmunprvpaicpaidom !== "") {
            getIhProvincias(data.locmunprvpaicpaidom).then((data) => {
              if (!data.toString().startsWith("Error:")) {
                setIhProvincias(data);
                setEstados((prevState) => ({
                  ...prevState,
                  provincias: true,
                }));
              }
            });
          }
          if (data.locmunprvpaicpaidom !== "" && data.locmunprvcprodom !== "") {
            getIhMunicipios(
              data.locmunprvpaicpaidom,
              data.locmunprvcprodom
            ).then((data) => {
              if (!data.toString().startsWith("Error:")) {
                setIhMunicipios(data);
                setEstados((prevState) => ({
                  ...prevState,
                  municipios: true,
                }));
              }
            });
          }
          if (
            data.locmunprvpaicpaidom !== "" &&
            data.locmunprvcprodom !== "" &&
            data.locmuncmunicipio !== ""
          ) {
            getIhLocalidades(
              data.locmunprvpaicpaidom,
              data.locmunprvcprodom,
              data.locmuncmunicipio
            ).then((data) => {
              if (!data.toString().startsWith("Error:")) {
                setIhLocalidades(data);
                setEstados((prevState) => ({
                  ...prevState,
                  localidades: true,
                  datos: true,
                }));
              }
            });
          }
        });
      } else {
        getDatosIhPersona().then((data) => {

          setDatos((prevState) => ({
            ...prevState,
            apellido1: data.apellido1,
            apellido2: data.apellido2,
            nombre: data.nombre,
            niep: data.niep,
            letiniiep: data.letiniiep,
            letfiniep: data.letfiniep,
            locclocalidad: data?.locclocalidad ? data?.locclocalidad : "0001",
            locmunprvcprodom: data?.locmunprvcprodom
              ? data?.locmunprvcprodom
              : "",
            cpostal: data?.cpostal ? data?.cpostal : "",
            dcalle: data?.dcalle ? data?.dcalle : "",
            locmunprvpaicpaidom: data?.locmunprvpaicpaidom
              ? data?.locmunprvpaicpaidom
              : "724",
            locmuncmunicipio: data?.locmuncmunicipio
              ? data?.locmuncmunicipio
              : "",
            ntelefono: data?.ntelefono ? data?.ntelefono : "",
            dtipvia: data?.dtipvia ? data?.dtipvia : "",
            ncalle: data?.ncalle ? data?.ncalle : "",
            escalera: data?.escalera ? data?.escalera : "",
            npiso: data?.npiso ? data?.npiso : "",
            puerta: data?.puerta ? data?.puerta : "",
            lbis: data?.lbis === "S" ? true : false,
            dacldom: data?.dacldom ? data?.dacldom : "",
            correoPersonal: data?.cemailper ? data?.cemailper : "",
            tipiep: data?.tipiep ? data?.tipiep : ""
          }));
          setEstados((prevState) => ({
            ...prevState,
            datos: true,
          }));
          if (data.locmunprvpaicpaidom !== "") {
            getIhProvincias(data.locmunprvpaicpaidom).then((data) => {
              if (!data.toString().startsWith("Error:")) {
                setIhProvincias(data);
                setEstados((prevState) => ({
                  ...prevState,
                  provincias: true,
                }));
              }
            });
          }
          if (data.locmunprvpaicpaidom !== "" && data.locmunprvcprodom !== "") {
            getIhMunicipios(
              data.locmunprvpaicpaidom,
              data.locmunprvcprodom
            ).then((data) => {
              if (!data.toString().startsWith("Error:")) {
                setIhMunicipios(data);
                setEstados((prevState) => ({
                  ...prevState,
                  municipios: true,
                }));
              }
            });
          }
          if (
            data.locmunprvpaicpaidom !== "" &&
            data.locmunprvcprodom !== "" &&
            data.locmuncmunicipio !== ""
          ) {
            getIhLocalidades(
              data.locmunprvpaicpaidom,
              data.locmunprvcprodom,
              data.locmuncmunicipio
            ).then((data) => {
              if (!data.toString().startsWith("Error:")) {
                setIhLocalidades(data);
                setEstados((prevState) => ({
                  ...prevState,
                  localidades: true,
                  datos: true,
                }));
              }
            });
          }
        });
      }
    }
    if (
      estados.datos &&
      estados.paises &&
      estados.tipVia &&
      estados.provincias
    ) {
      setLoading(true);
    }


  }, [estados, location, params.id, user, ihTipVia,datos.locmunprvpaicpaidom]);

  return (
    <>
      <Header></Header>
      <div className="container d-flex flex-column card mt-5" id="inicio" role="main" data-landmark-index="4">
        {loading ? (
          <>


            <Formik
              // enableReinitialize={true}
              initialValues={{
                nombreBorrador: datos?.nombreBorrador
                  ? datos.nombreBorrador
                  : `Borrador ${new Date().toLocaleDateString("es-ES")} ${new Date().toLocaleTimeString("es-ES", {
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: false
                  })}`
                ,                niep:
                  datos?.niep === ""
                    ? ""
                    : `${datos?.letiniiep ? datos?.letiniiep : ""}${datos?.niep}${datos?.letfiniep ? datos?.letfiniep : ""}`,
                tipiep: datos?.tipiep === "" ? "" : datos?.tipiep,
                nombre: datos?.nombre === "" ? "" : datos?.nombre,
                apellido1:
                  datos?.apellido1 === "" ? "" : datos?.apellido1,
                apellido2:
                  datos?.apellido2 === "" ? "" : datos?.apellido2,
                dtipvia: datos?.dtipvia ? datos.dtipvia : "",
                dcalle: datos?.dcalle === "" ? "" : datos?.dcalle,
                ncalle: datos?.ncalle === "" ? "" : datos?.ncalle,
                lbisC: !!datos?.lbis,
                escalera:
                  datos?.escalera === "" ? "" : datos?.escalera,
                npiso: datos?.npiso === "" ? "" : datos?.npiso,
                puerta: datos?.puerta === "" ? "" : datos?.puerta,
                cpostal: datos?.cpostal === "" ? "" : datos?.cpostal,
                ntelefono:
                  datos?.ntelefono === "" ? "" : datos?.ntelefono,
                locclocalidad:
                  datos?.locclocalidad === ""
                    ? ""
                    : datos?.locclocalidad,
                locmunprvpaicpaidom:
                  datos?.locmunprvpaicpaidom === ""
                    ? ""
                    : datos?.locmunprvpaicpaidom,
                locmuncmunicipio:
                  datos?.locmuncmunicipio === ""
                    ? ""
                    : datos?.locmuncmunicipio,
                locmunprvcprodom:
                  datos?.locmunprvcprodom === ""
                    ? ""
                    : datos?.locmunprvcprodom,
                dacldom: datos?.dacldom === "" ? "" : datos?.dacldom,
                correoPersonal: datos?.correoPersonal === "" ? "" : datos?.correoPersonal
              }}
              validate={(valores) => {
                const errores = {};

                if (valores.dcalle == null || valores.via === "") {
                  errores.dcalle = "Debe introducir una vía.";
                }





                if (valores.nombreBorrador == null || valores.nombreBorrador === "") {
                  errores.nombreBorrador = "Debe introducir un nombre para el borrador.";
                }

                if (
                  valores.ntelefono !== "" && valores.ntelefono != null && valores.ntelefono !== undefined && !/\(?([0-9]{3})\)?([ -]?)([0-9]{3})\2([0-9]{3})$/.test(valores.ntelefono)
                ) {
                  errores.ntelefono = "Debe introducir un número de teléfono válido.";
                }

                if (valores.dtipvia == null || valores.dtipvia === "") {
                  errores.dtipvia = "Debe introducir un tipo de vía.";
                }

                if (valores.dcalle == null || valores.dcalle === "") {
                  errores.dcalle = "Debe introducir la calle.";
                }

                if (valores.ncalle == null || valores.ncalle === "") {
                  errores.ncalle = "Debe introducir un número.";
                }

                if (valores.locmunprvpaicpaidom == null || valores.locmunprvpaicpaidom === "") {
                  errores.locmunprvpaicpaidom = "Debe introducir un país.";
                }

                // ✅ Solo validamos provincia / municipio / localidad si el país es España
                const esEspana = valores.locmunprvpaicpaidom === "724";

                if (esEspana) {
                  if (!valores.locmunprvcprodom) {
                    errores.locmunprvcprodom = "Debe introducir una provincia.";
                  }
                  if (!valores.locmuncmunicipio) {
                    errores.locmuncmunicipio = "Debe introducir un municipio.";
                  }
                  if (!valores.locclocalidad) {
                    errores.locclocalidad = "Debe introducir una localidad.";
                  }
                  if (!valores.cpostal) {
                    errores.cpostal = "Debe introducir un Código Postal.";
                  }
                  if (
                    valores.cpostal &&
                    !/^(0[1-9]|[1-4][0-9]|5[0-2])[0-9]{3}$/.test(valores.cpostal)
                  ) {
                    errores.cpostal = "Código postal inválido.";
                  }
                }


                if (
                  valores.correoPersonal != null &&
                  valores.correoPersonal !== "" &&
                  !/^[a-z0-9._-]+@[a-z0-9.-]+\.[a-z]{2,4}$/i.test(valores.correoPersonal)
                ) {
                  errores.correoPersonal = "Correo electrónico no válido.";
                }


                return errores;
              }}

              onSubmit={(valores) => {

                valores.letfiniep = user?.letniep;
                if (datos?.letiniiep !== undefined && datos?.letiniiep !== null && datos?.letiniiep !== "") {
                  valores.letiniiep = datos?.letiniiep;
                }

                eliminarPropiedadObj(valores, "xniep");
                valores.lbis = valores.lbisC ? "S" : "N";

                eliminarPropiedadObj(valores, "lbisC");


                setShow({
                  mensaje: true,
                  content:
                    "¿Desea guardar este borrador?",
                  contentBold: "NO QUEDA PRESENTADA ",

                  tipo: "tituloModal",
                  funcion: mandarBorrador,
                  valorFuncion: valores,
                  aviso: true,
                  destinoAviso: null,
                  destinoCerrar: null,
                });
              }}
            >
              {({ errors, values, setFieldValue, setErrors, setTouched }) => (
                <>
                  <Form>
                    <>
                      <div className="my-auto">
                        <div className="tituloSolicitud pb-2">
                          <div className="d-flex align-items-center flex-column">
                            {/*<Titulo
                                titulo={"Acto S1 Variación de datos personales"}
                                tipo={"tituloPagina subTituloPagina"}
                              />*/}
                            <h2 className="tituloPagina">Acto S1 Variación de datos personales</h2>
                            <p className="text-third-1">{datos.estado}</p>
                          </div>
                          <div className="datosPersonalesCarrera d-flex flex-column m-2">
                            <div className="formulario">
                              <div className="me-lg-2 col-6">
                                <label htmlFor="nombreBorrador">
                                  Nombre Borrador{" "}
                                  <span className="rojo">*</span>:
                                </label>
                                <Field
                                  type="text"
                                  id="nombreBorrador"
                                  name="nombreBorrador"
                                  className="form-control"
                                  maxLength="60"
                                />
                                <ErrorMessage
                                  name="nombreBorrador"
                                  component={() => (
                                    <div className="error rojo pt-2">
                                      {errors.nombreBorrador}
                                    </div>
                                  )}
                                />
                              </div>
                              <div className="d-flex justify-content-between">
                                {/*<Titulo
                                    clases={"subSubTituloSolicitud p-2 fw-bold"}
                                    tipo={"tituloCard noBg"}
                                    titulo={"1. Datos personales"}
                                  ></Titulo>*/}
                                <h3 className="tituloPagina">1. Datos personales</h3>

                                <p className="p-3 text-third-1">
                                  Campo obligatorio *
                                </p>
                              </div>
                              <div className="gridBorradorActos p-2">
                                <div className="dniActos me-lg-2">
                                  <label htmlFor="niep">DNI:</label>
                                  <Field
                                    type="text"
                                    id="niep"
                                    name="niep"
                                    className="form-control"
                                    readOnly
                                    disabled
                                  />
                                </div>

                                <div className="nombreActos">
                                  <label htmlFor="nombre">Nombre:</label>
                                  <Field
                                    type="text"
                                    id="nombre"
                                    name="nombre"
                                    className="form-control"
                                    readOnly
                                    disabled
                                  />
                                </div>
                                <div className="ape1Actos me-lg-2">
                                  <label htmlFor="apellido1">
                                    Primer Apellido:
                                  </label>
                                  <Field
                                    type="text"
                                    id="apellido1"
                                    name="apellido1"
                                    className="form-control"
                                    readOnly
                                    disabled
                                  />
                                </div>
                                <div className="ape2Actos ">
                                  <label htmlFor="apellido2">
                                    Segundo Apellido:
                                  </label>
                                  <Field
                                    type="text"
                                    id="apellido2"
                                    name="apellido2"
                                    className="form-control"
                                    readOnly
                                    disabled
                                  />
                                </div>
                                <div className="tipViaActos me-lg-2">
                                  <label htmlFor="dtipvia">
                                    Tipo de Vía{" "}
                                    <span className="rojo">*</span>:
                                  </label>
                                  <Field
                                    as="select"
                                    id="dtipvia"
                                    name="dtipvia"
                                    className="form-select"
                                  // defaultValue={
                                  //   datos?.dtipvia
                                  //     ? datos?.dtipvia
                                  //     : ""
                                  // }
                                  // value={undefined}
                                  >
                                    <option value="" disabled >
                                      Selecciona...
                                    </option>
                                    {/* {} */}

                                    {ihTipVia.map((tipo, i) => (
                                      <option value={tipo.codigo} key={i}>
                                        {tipo.valor}
                                      </option>
                                    ))}
                                  </Field>

                                  <ErrorMessage
                                    name="dtipvia"
                                    component={() => (
                                      <div className="error rojo pt-2">
                                        {errors.dtipvia}
                                      </div>
                                    )}
                                  />
                                </div>
                                <div className="viaActos me-lg-2">
                                  <label htmlFor="dcalle">
                                    Vía <span className="rojo">*</span>:
                                  </label>
                                  <Field
                                    type="text"
                                    id="dcalle"
                                    name="dcalle"
                                    className="form-control"
                                    maxLength="39"
                                  />
                                  <ErrorMessage
                                    name="dcalle"
                                    component={() => (
                                      <div className="error rojo pt-2">
                                        {errors.dcalle}
                                      </div>
                                    )}
                                  />
                                </div>
                                <div className="numeroActos">
                                  <div className="numero">
                                    <label htmlFor="ncalle">
                                      Nº <span className="rojo">*</span>:
                                    </label>
                                    <Field
                                      type="text"
                                      id="ncalle"
                                      name="ncalle"
                                      className="form-control"
                                      maxLength="5"
                                    />
                                  </div>
                                  <div className="mensajeNumeroBis">
                                    <ErrorMessage
                                      name="ncalle"
                                      component={() => (
                                        <div className="error rojo pt-2">
                                          {errors.ncalle}
                                        </div>
                                      )}
                                    />
                                  </div>
                                </div>
                                <div className="lbisActos mt-2 ms-2">
                                  <label htmlFor="lbisC">Bis:</label>
                                  <br></br>
                                  {""}
                                  <Field
                                    type="checkbox"
                                    id="lbisC"
                                    name="lbisC"
                                    className="form-check-input"
                                  />
                                </div>
                                <div className="escaleraActos me-lg-2 mt-2">
                                  <label htmlFor="escalera">Escalera:</label>
                                  <Field
                                    type="text"
                                    id="escalera"
                                    name="escalera"
                                    className="form-control"
                                    maxLength="5"
                                  />
                                </div>
                                <div className="pisoActos mt-2">
                                  <label htmlFor="npiso">Piso:</label>
                                  <Field
                                    type="text"
                                    id="npiso"
                                    name="npiso"
                                    className="form-control"
                                    maxLength="5"
                                  />
                                </div>
                                <div className="puertaActos me-lg-2">
                                  <label htmlFor="puerta">Puerta:</label>
                                  <Field
                                    type="text"
                                    id="puerta"
                                    name="puerta"
                                    className="form-control"
                                    maxLength="5"
                                  />
                                </div>
                                <div className="aclaradorActos">
                                  <label htmlFor="dacldom">
                                    Aclarador:
                                  </label>
                                  <Field
                                    type="text"
                                    id="dacldom"
                                    name="dacldom"
                                    className="form-control"
                                    maxLength="39"
                                  />
                                  <ErrorMessage
                                    name="dacldom"
                                    component={() => (
                                      <div className="error rojo pt-2">
                                        {errors.dacldom}
                                      </div>
                                    )}
                                  />
                                </div>
                                {/* <div className="paisActos me-lg-2">
                                  <label htmlFor="locmunprvpaicpaidom">
                                    Pais<span className="rojo"> *</span>:
                                  </label>
                                  <Field
                                    as="select"
                                    id="locmunprvpaicpaidom"
                                    name="locmunprvpaicpaidom"
                                    className="form-select"
                                    value={values.locmunprvpaicpaidom || ""}
                                    onChange={(e) => {
                                      const pais = e.target.value;
                                      setFieldValue("locmunprvpaicpaidom", pais);
                                      handlePais(pais, setFieldValue);
                                    }}

                                  >
                                    <option value="" disabled>
                                      Selecciona una opción
                                    </option>
                                    {ihPaises.map((pais, i) => (
                                      <option
                                        value={pais.cpais}
                                        key={i}
                                        defaultValue={pais.cpais === "724"}
                                      >
                                        {pais.dpais}
                                      </option>
                                    ))}
                                  </Field>
                                  <ErrorMessage
                                    name="locmunprvpaicpaidom"
                                    component={() => (
                                      <div className="error rojo ">
                                        {errors.locmunprvpaicpaidom}
                                      </div>
                                    )}
                                  />
                                </div> */}
                                <div className="paisActos me-lg-2">
                                  <label htmlFor="locmunprvpaicpaidom">
                                    País<span className="rojo"> *</span>:
                                  </label>

                                  <Field
                                    as="select"
                                    id="locmunprvpaicpaidom"
                                    name="locmunprvpaicpaidom"
                                    className="form-select"
                                    value={values.locmunprvpaicpaidom || ""}
                                    onChange={(e) => {
                                      const pais = e.target.value;

                                      // Actualizar país en Formik
                                      setFieldValue("locmunprvpaicpaidom", pais);

                                      // Tu lógica para resetear combos / cargar provincias
                                      handlePais(pais, setFieldValue);

                                      // 🔹 LIMPIAR ERRORES de los campos dependientes
                                      setErrors((prev) => ({
                                        ...prev,
                                        locmunprvcprodom: undefined,
                                        locmuncmunicipio: undefined,
                                        locclocalidad: undefined,
                                        cpostal: undefined,
                                      }));

                                      // 🔹 LIMPIAR TOUCHED de los campos dependientes
                                      setTouched((prev) => ({
                                        ...prev,
                                        locmunprvcprodom: false,
                                        locmuncmunicipio: false,
                                        locclocalidad: false,
                                        cpostal: false,
                                      }));
                                    }} 
                                    disabled
                                  > 
                                    <option value="" disabled>
                                      Selecciona una opción
                                    </option>
                                    {ihPaises.map((pais, i) => (
                                      <option value={pais.cpais} key={i}>
                                        {pais.dpais}
                                      </option>
                                    ))}
                                  </Field>

                                  <ErrorMessage
                                    name="locmunprvpaicpaidom"
                                    component={() => (
                                      <div className="error rojo ">
                                        {errors.locmunprvpaicpaidom}
                                      </div>
                                    )}
                                  />
                                </div>

                                <div className="provinciaActos">
                                  <label htmlFor="locmunprvcprodom">
                                    Provincia{(values?.locmunprvpaicpaidom === "724") && <span className="rojo"> *</span>}:
                                  </label>
                                  {/* {estados.provincias ? ( */}
                                  <Field
                                    as="select"
                                    id="locmunprvcprodom"
                                    name="locmunprvcprodom"
                                    className="form-select"
                                    value={values.locmunprvcprodom || ""}

                                    onChange={(e) => {
                                      const provincia = e.target.value;
                                      setFieldValue("locmunprvcprodom", provincia);
                                      handleProvincia({ ...values, locmunprvcprodom: provincia }, setFieldValue);
                                    }}

                                    disabled={values.locmunprvpaicpaidom !== "724"}
                                  >
                                    <option value="">
                                      Selecciona una opción
                                    </option>
                                    {IhProvincias.map((provincia, i) => (
                                      <option
                                        value={provincia.cprovincia}
                                        key={i}
                                      >
                                        {provincia.dprovincia}
                                      </option>
                                    ))}
                                  </Field>
                                  {/*  ) : (
                                    <SpinnerCircleMini></SpinnerCircleMini>
                                  )}*/}
                                  <ErrorMessage
                                    name="locmunprvcprodom"
                                    component={() => (
                                      <div className="error rojo pt-2">
                                        {errors.locmunprvcprodom}
                                      </div>
                                    )}
                                  />
                                </div>
                                <div className="municipioActos me-lg-2">
                                  <label htmlFor="locmuncmunicipio">
                                    Municipio{(values?.locmunprvpaicpaidom === "724") && <span className="rojo"> *</span>}:
                                  </label>
                                  {/* {estados.municipios ? ( */}
                                  <Field
                                    as="select"
                                    id="locmuncmunicipio"
                                    name="locmuncmunicipio"
                                    className="form-select"
                                    defaultValue={
                                      datos?.locmuncmunicipio
                                        ? datos?.locmuncmunicipio
                                        : ""
                                    }

                                    onChange={(e) => {
                                      const municipio = e.target.value;
                                      setFieldValue("locmuncmunicipio", municipio);
                                      handleMuncipios({ ...values, locmuncmunicipio: municipio }, setFieldValue);
                                    }}
                                    disabled={(values.locmunprvpaicpaidom !== "724") || values.locmunprvcprodom === ""}
                                  >
                                    <option value="">
                                      Selecciona una opción
                                    </option>
                                    {ihMunicipios.map((municipio, i) => (
                                      <option
                                        value={municipio.cmunicipio}
                                        key={i}
                                      >
                                        {municipio.dmunicipio}
                                      </option>
                                    ))}
                                  </Field>
                                  {/*  // ) : (
                                  //   <div className="error rojo pt-2">
                                  //     Seleccione una muni.
                                  //   </div>
                                  // )}*/}
                                  <ErrorMessage
                                    name="locmuncmunicipio"
                                    component={() => (
                                      <div className="error rojo pt-2">
                                        {errors.locmuncmunicipio}
                                      </div>
                                    )}
                                  />
                                </div>

                                <div className="localidadActos">
                                  <label htmlFor="locclocalidad">
                                    Localidad{(values?.locmunprvpaicpaidom === "724") && <span className="rojo"> *</span>}:
                                  </label>
                                  {/* {estados.localidades ? ( */}
                                  <Field
                                    as="select"
                                    name="locclocalidad"
                                    className="form-select"
                                    defaultValue={
                                      datos?.locclocalidad
                                        ? datos?.locclocalidad
                                        : ""
                                    }

                                    disabled={(values.locmunprvpaicpaidom !== "724") || values.locmuncmunicipio === ""}>
                                    <option value="">Selecciona una opción</option>
                                    {ihLocalidades.map((localidad, i) => (
                                      <option value={localidad.clocalidad} key={i}>
                                        {localidad.dlocalidad}
                                      </option>
                                    ))}
                                  </Field>

                                  {/* ) : (
                                  //   <div className="error rojo pt-2">
                                  //     Seleccione un municipio.
                                  //   </div>
                                  // )}*/}

                                  <ErrorMessage
                                    name="locclocalidad"
                                    component={() => (
                                      <div className="error rojo pt-2">
                                        {errors.locclocalidad}
                                      </div>
                                    )}
                                  />
                                </div>

                                <div className="cpostalActos me-lg-2">
                                  <label htmlFor="cpostal">
                                    CP{(values?.locmunprvpaicpaidom === "724") && <span className="rojo"> *</span>}:
                                  </label>
                                  <input
                                    type="text"
                                    name="cpostal"
                                    disabled={(values.locmunprvpaicpaidom !== "724") || IhProvincias.length === 0}
                                    value={values?.locmunprvpaicpaidom === "724" ? values.cpostal || "" : ""}
                                    className="form-control"
                                    maxLength={5}
                                    onKeyDown={(e) => {
                                      const allowedKeys = ["Backspace", "Delete"];
                                      if (allowedKeys.includes(e.key)) return;

                                      if (e.key === " ") e.preventDefault();
                                      if (/[a-zA-Z]/.test(e.key)) e.preventDefault();
                                    }}
                                    onChange={(e) => {
                                      // Permitir borrar
                                      const cleaned = e.target.value.replace(/[^\d]/g, "");
                                      setFieldValue("cpostal", cleaned);
                                    }}
                                  />



                                  <ErrorMessage
                                    name="cpostal"
                                    component={() => (
                                      <div className="error rojo pt-2">
                                        {errors.cpostal}
                                      </div>
                                    )}
                                  />
                                </div>

                                <div className="tlfContactoActos">
                                  <label htmlFor="ntelefono">
                                    Teléfono de contacto:

                                  </label>
                                  <Field
                                    type="text"
                                    id="ntelefono"
                                    name="ntelefono"
                                    className="form-control"
                                    maxLength="9"
                                    onKeyDown={(e) => {
                                      const allowedKeys = ["Backspace", "Delete"];
                                      if (allowedKeys.includes(e.key)) return;

                                      if (e.key === " ") e.preventDefault();
                                      if (/[a-zA-Z]/.test(e.key)) e.preventDefault();
                                    }}
                                    onChange={(e) => {
                                      // Permitir borrar
                                      const cleaned = e.target.value.replace(/[^\d]/g, "");
                                      setFieldValue("ntelefono", cleaned);
                                    }}
                                  />
                                  <ErrorMessage
                                    name="ntelefono"
                                    component={() => (
                                      <div className="error rojo pt-2">
                                        {errors.ntelefono}
                                      </div>
                                    )}
                                  />
                                </div>

                                <div className="correoPersonalActos me-2">
                                  <label htmlFor="correoPersonal">
                                    Correo personal:
                                  </label>
                                  <Field
                                    type="email"
                                    id="correoPersonal"
                                    name="correoPersonal"
                                    className="form-control"
                                    maxLength="99"
                                  />
                                  <ErrorMessage
                                    name="correoPersonal"
                                    component={() => (
                                      <div className="error rojo pt-2">
                                        {errors.correoPersonal}
                                      </div>
                                    )}
                                  />
                                </div>

                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>

                    {/* <div className="datosProfesionales">
                                <div className="separador "></div>
                                <Titulo
                                  clases={"subSubTituloSolicitud p-2 fw-bold"}
                                  tipo={"tituloCard noBg"}
                                  titulo={"2. Documentación"}
                                ></Titulo>
                                <div className="separador "></div>

                                <div className="m-2"></div>

                                <div className="separador "></div>
                              </div> */}
                    {/* <div className="footer">
                                <div className="direccion d-flex flex-column align-items-center  text-center">
                                  <p>DIRECCIÓN GENERAL DE FUNCIÓN PÚBLICA</p>
                                  <p>
                                    Servicio de Gestión y Provisión de Personal
                                  </p>
                                  <p className="text-center">
                                    Avda. Valhondo, s/n Edificio III Milenio -
                                    Módulo 1 - 1ª Planta - 06800 Mérida
                                  </p>
                                </div>
                              </div> */}
                    <div className=" row d-flex justify-content-center align-items-center gap-2 mb-1">
                      <div className="col-md-5 order-0 order-md-1">
                        <button
                          id="grabarSolicitudCarrera"
                          className="btn rounded btnGuardarBorradorS1 "
                          type="submit"
                          onClick={
                            Object.keys(errors).length === 0
                              ? () => { values.tipo = "borrador"; }
                              : () => {
                                setShow({
                                  mensaje: true,
                                  content: "Debe completar correctamente los datos obligatorios (Datos personales).",
                                  tipo: "tituloModal rojo",
                                  destinoAviso: null,
                                  destinoCerrar: null,
                                });
                              }
                          }
                        >
                          <i className="fa-solid fa-save"></i> Guardar
                        </button>
                      </div>

                      <div className="col-md-5 order-1 order-md-0">
                        <button
                          id="volver"
                          className="btnRed rounded btnSalirBorradorS1 py-1 d-flex align-items-center"
                          type="button"
                          onClick={() =>
                            setShow({
                              mensaje: true,
                              content:
                                "¿Deseas cancelar el formulario?",
                              tipo: "tituloModal",
                              aviso: true,
                              destinoAviso: "/variacionDatosPersonales",
                              destinoCerrar: null,
                            })
                          }
                        >
                          <i className="fa-solid fa-rotate-left me-1" /> Volver

                        </button>
                      </div>



                    </div>

                  </Form>
                </>
              )}
            </Formik>


          </>
        ) : (
          <>
            <div className="error rojo fs-4 pt-2 d-flex align-items-center flex-column my-auto">
              {estado ? (
                <>
                  {datos.estado}
                  <div className="gridBotones mb-2">
                    <button
                      id="volver"
                      className="btnRed btnSalirBorrador btnCancelarDocumentacion rounded order-2 order-md-1 w-25 py-2"
                      type="button"
                      onClick={() => {

                        navigate("/home")

                      }}
                    >
                      <i className="fa-solid fa-rotate-left"></i> Volver
                    </button>
                  </div>
                </>
              ) : (
                <SpinnerCircle></SpinnerCircle>
              )}
            </div>
          </>
        )}
      </div>
      <Footer></Footer>
      {show.mensaje ? (
        <>
          {" "}
          <ModalMensajes
            show={show.mensaje}
            handleClose={handleClose}
            content={show.content}
            content2={show.content2}
            tipo={show.tipo}
            aviso={show.aviso}
            destinoAviso={show.destinoAviso}
            destinoCerrar={show.destinoCerrar}
            funcion={show.funcion}
            valorFuncion={show.valorFuncion}
            boton={show.boton}
            contentBold={show.contentBold}
          ></ModalMensajes>
        </>
      ) : null}

      {show.modalPresentar ? (
        <ModalPresentar
          show={true}
          handleClose={handleClose}
          valores={show.valores}
          destinoCerrar={show?.destinoCerrar}
        ></ModalPresentar>
      ) : null}
    </>
  );
};
export default BorradorActos;
